import { card, btn, btnGhost, label } from "./_genCommon";

/** Step 2: progress + live alts grid while generating, with per-alt status. */
export default function GenerateStep({ job, alts, onCancel }) {
  const curIdx = job?.current_alt_idx || 0;
  const curTotal = job?.current_alt_total || job?.config?.num_alternatives || "?";
  const curStrategy = job?.current_alt_strategy_name || "";
  const curId = job?.current_alt_id || "";
  return (
    <div data-testid="gen-running" style={{ padding: 24 }}>
      <div style={{ ...card, padding: 24, maxWidth: 700, margin: "0 auto",
                          textAlign: "center" }}>
        <div style={{ fontSize: 16, fontWeight: 600 }}>Generating alternatives…</div>
        <div data-testid="gen-current-alt" style={{ marginTop: 8, fontSize: 12,
                          color: "#F26B1F", minHeight: 18 }}>
          {job?.status === "running" && curStrategy
              ? <>Generating <b>ALT-{String(curIdx).padStart(2, "0")}</b> · "{curStrategy}"
                    {" "}<span style={{ color: "var(--pf-muted)" }}>
                      ({curIdx} of {curTotal})
                    </span></>
              : "Queued…"}
        </div>
        <div style={{ marginTop: 8, fontSize: 11, color: "var(--pf-muted)" }}>
          {job
              ? `${job.alternatives_so_far || 0} of ${curTotal} complete`
              : "Queued…"}
        </div>
        <div style={{ marginTop: 20, height: 10, background: "var(--pf-bg)",
                          borderRadius: 4, overflow: "hidden",
                          border: "1px solid var(--pf-border)" }}>
          <div style={{ width: `${job?.progress || 0}%`, height: "100%",
                            background: "linear-gradient(90deg, #F26B1F, #FF8C42)",
                            transition: "width .3s" }} />
        </div>
        <div style={{ marginTop: 6, fontSize: 11, color: "#F26B1F" }}>
          {job?.progress || 0} %
        </div>
        <button data-testid="gen-cancel" style={{ ...btnGhost, marginTop: 16 }}
            onClick={onCancel}>✕ Cancel generation</button>
      </div>
      {alts?.length > 0 && (
        <div style={{ ...card, padding: 14, marginTop: 16 }}>
          <div style={label}>Live results ({alts.length} ready)</div>
          <div style={{ display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                            gap: 8, marginTop: 8 }}>
            {alts.map(a => (
              <div key={a.id} style={{ background: "var(--pf-bg)",
                                                  border: a.id === curId
                                                              ? "1px solid #F26B1F"
                                                              : "1px solid var(--pf-border)",
                                                  borderRadius: 4, padding: 8 }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: "#F26B1F" }}>
                  {a.id}
                </div>
                <div style={{ fontSize: 10, color: "var(--pf-muted)", marginTop: 2 }}>
                  {a.strategy_name || ""}
                </div>
                <div style={{ fontSize: 10, marginTop: 4 }}>
                  CAPEX <b>{a.cost?.capex_INR_cr}</b> cr · {a.schedule?.months} mo
                </div>
                <div style={{ fontSize: 10, color: "var(--pf-muted)" }}>
                  Score: <b>{a.scores?.weighted_total ?? "—"}</b>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
